export default "__VITE_ASSET__d99f61f1__"